// apiClient.ts
import axios from 'axios';
import { SERVER_URL } from 'src/constants';
import { requestHandler, errorResponseHandler } from './interceptor';
import { successResponseHandler } from '../axios/interceptors';

const axiosWithInterceptor = axios.create({
    baseURL: SERVER_URL,
});

axiosWithInterceptor.interceptors.request.use(requestHandler);
axiosWithInterceptor.interceptors.response.use(successResponseHandler, errorResponseHandler);

export default axiosWithInterceptor;
